import { createSelector } from "@reduxjs/toolkit";

import { IDataKeys, IJSONAPIItem } from "shared/types";
import { buildSingleItem } from "shared/utils";
import { dataSelector } from "./helpers";

export const eventDetailsExportSelector = () =>
  createSelector(dataSelector, (data: any) => {
    if (data.eventDetailsExport) {
      const detailsExport = Object.values(
        data?.eventDetailsExport
      )[0] as IJSONAPIItem;

      return buildSingleItem(detailsExport);
    }

    return null;
  });

export const lastEventDetailsExportSent = (id?: string) =>
  createSelector(dataSelector, (data: any) => {
    if (
      data[IDataKeys.lastEventDetailsExportSent] &&
      id &&
      data[IDataKeys.lastEventDetailsExportSent][id]
    ) {
      const detailsExport = data[IDataKeys.lastEventDetailsExportSent][
        id
      ] as IJSONAPIItem;

      return buildSingleItem(detailsExport);
    }

    return null;
  });
